// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-650c","taskPricing":"taskPricing-728b","image":"image-d610"};